import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
// Import Types
import type { DynamicVariableChannelData } from 'types';
// Import UI Components
import { Alert, Icon, Tooltip } from '@geneui/components';
// Import Components
import BlockedBySubscriptionInfo from 'components/common/BlockedBySubscriptionInfo';
// Import Enums
import { TemplateValueTypeEnum } from 'enums';
// Import Constants
import { BLOCKED_BY_SUBSCRIPTION_CLASSNAME, l } from 'constants/common';

const DynamicVariables = ({ dynamicVariables, clickHandler, insertionOptions }) => {
    const { t } = useTranslation();

    const filteredDynamicVariables: DynamicVariableChannelData[] = dynamicVariables.filter((el) => {
        if (insertionOptions.inputFilterKey) {
            return el.channels[insertionOptions.channel]?.[insertionOptions.inputFilterKey];
        }

        return el.channels[insertionOptions.channel];
    });

    return (
        <div className="crm-create-template-page-variables-row">
            <div className="crm-create-template-page-variables-row-head">
                <span>{t(l.DynamicVariables)}</span>
                <Tooltip
                    size="default"
                    title={t(l.TemplateDynamicVariablesTooltipTitle)}
                    text={t(l.TemplateDynamicVariablesTooltipText)}
                >
                    <i className="bc-icon-info" />
                </Tooltip>
            </div>
            <div className="crm-create-template-page-variables-container">
                {insertionOptions.hintText ? (
                    <Alert
                        closable={false}
                        title={t(insertionOptions.hintText)}
                        type="info"
                        className="partner-group-alert"
                    />
                ) : (
                    <div className="crm-create-template-page-variables-row-content">
                        {filteredDynamicVariables.map((item) => {
                            const dynamicVariableForType = item.channels[insertionOptions.channel];
                            const { isBlocked, isDisabled, FieldName, TypeConfig } = dynamicVariableForType;
                            return (
                                <BlockedBySubscriptionInfo key={FieldName} isBlocked={isBlocked} position="top">
                                    <div
                                        className={classNames({
                                            [BLOCKED_BY_SUBSCRIPTION_CLASSNAME]: isDisabled || isBlocked,
                                            'not-clickable': isDisabled || isBlocked,
                                        })}
                                    >
                                        <button
                                            onClick={() => clickHandler(dynamicVariableForType)}
                                            className="crm-custom-btn"
                                            disabled={isDisabled || isBlocked}
                                        >
                                            {t(item.displayNameKey)}

                                            {TypeConfig?.ValueType === TemplateValueTypeEnum.Link && (
                                                <Icon type="bc-icon-link" className="crm-custom-btn-icon" />
                                            )}

                                            {TypeConfig?.ValueType === TemplateValueTypeEnum.Image && (
                                                <Icon type="bc-icon-image" className="crm-custom-btn-icon" />
                                            )}
                                        </button>
                                    </div>
                                </BlockedBySubscriptionInfo>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

DynamicVariables.propTypes = {
    dynamicVariables: PropTypes.arrayOf(PropTypes.object),
    clickHandler: PropTypes.func,
    activeChannel: PropTypes.string,
    insertionOptions: PropTypes.shape({
        inputFilterKey: PropTypes.string,
        hintText: PropTypes.string,
        channel: PropTypes.string,
    }),
};

export default DynamicVariables;
